import { SyntheticEvent } from "react";

export function preventDefault(f: (e: SyntheticEvent) => void) {
  return (e: SyntheticEvent) => {
    e.preventDefault();
    return f(e);
  };
}

// a simple a handler for input change events
export const handleChange =
  (setter: (value: string) => void) =>
  (
    e: React.FormEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setter(e.currentTarget.value);
  };
